
  import { defineComponent } from 'vue';
  import {
    QuestionOptions
  } from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/QuestionOptions';
  import { Icon } from '@/ui/components/icon/Icon';

  interface PreviewFileProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    entities: any;
  }

  export default defineComponent<PreviewFileProps>({
    name: 'ConductInspectionItemQuestionFile',
    components: {
      QuestionOptions,
      Icon,
    },
    props: ['item', 'entities'],
  });
